import { isValidPhoneNumber } from 'libphonenumber-js/max';
import validator from 'validator';

const NON_DIGIT_PHONE_SEPARATORS = /[\s()-]/g;
const AUSTRALIAN_MOBILE_NUMBER = /^(?:\+?61|0)4\d{8}$/;

export const normalizePhoneNumber = (value: string): string => {
  return value.replace(NON_DIGIT_PHONE_SEPARATORS, '');
};

export const stringsNotEmpty = (values: string[]): boolean => {
  return values.every((value) => value.trim() !== '');
};

export const isValueObject = (value: unknown): value is { value: unknown } => {
  return typeof value === 'object' && value !== null && 'value' in value;
};

export const isValidAustralianMobileNumber = (value: string): boolean => {
  const normalizedValue = normalizePhoneNumber(value);

  return AUSTRALIAN_MOBILE_NUMBER.test(normalizedValue);
};

export const isValidMobilePhoneValue = (value: string): boolean => {
  const normalizedValue = normalizePhoneNumber(value);

  return isValidAustralianMobileNumber(normalizedValue) || validator.isMobilePhone(normalizedValue);
};

export const isValidPhoneValue = (value: string): boolean => {
  const normalizedValue = normalizePhoneNumber(value);

  return isValidAustralianMobileNumber(normalizedValue) || isValidPhoneNumber(normalizedValue);
};
